import { array, nullable, number, object, string } from "superstruct";

import InstagramPostMediaSchema from "./InstagramPostMediaSchema";
import InstagramPostTagSchema from "./InstagramPostTagSchema";

const InstagramPostSchema = object({
    id: number(),
    permalink: string(),
    objectId: string(),
    caption: nullable(string()),
    media: array(InstagramPostMediaSchema),
    tags: array(InstagramPostTagSchema),
});

export default InstagramPostSchema;
